export enum GalleryLayout {
    CAROUSEL = 'carousel',
    GRID = 'grid',
}

// 5 is skipped on purpose -- it's landlord images, which aren't part of the property gallery.
export enum ImageCategory {
    EXTERIOR_SHOTS = 1,
    OUTDOOR_SURROUNDING = 2,
    FEATURES = 3,
    GROUND_PLAN = 4,
    DOCUMENTS = 6,
    LIVING_ROOM = 7,
    BEDROOM = 8,
    BATHROOM = 9,
    KITCHEN = 10,
    SWIMMING_POOL = 11,
    MISCELLANEOUS = 100,
}

export enum CategoryBrowseTab {
    ALL = 'all',
    VIDEO = 'video',
}

export type CategoryTab = CategoryBrowseTab | ImageCategory

export interface CategoryTabOption {
    key: CategoryTab
    translationKey: string
}

export type ImageCategoryTabOption = CategoryTabOption & { key: ImageCategory }

export interface SlideCounter {
    current: number
    total: number
}

export interface Image {
    src: string
    thumbnail?: string
    caption: string
    category?: ImageCategory
}
export interface GalleryImageClickContext {
    imageIndex: number
    layout: GalleryLayout
}

export interface GalleryProps {
    header?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    images: Image[]
    video?: Image
    skipFullScreen?: boolean
    skipOverlay?: boolean
    showDots?: boolean
    showArrows?: boolean
    showCountTile?: boolean
    autoPlay?: boolean
    onSlideChange?: (index: number) => void
    imageBorderRadius?: string
    imageBorder?: string
    layout?: GalleryLayout
    onGalleryImageClick?: (context: GalleryImageClickContext) => void
    onViewAllClick?: () => void
    onFullscreenImageClick?: (imageIndex: number) => void
    onFullScreenOpen?: () => void
    onOverlayOpen?: () => void
    viewAllText?: string
    fontFamily?: string
    galleryIconSrc?: string
    enableCategorizedGallery?: boolean
}

export interface FullScreenModalProps {
    images: Image[]
    video?: Image
    isFullScreenOpen: boolean
    isOverlayOpen: boolean
    setFullScreen: (isOpen: boolean) => void
    header?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    setOverlay: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedImage: (index: number) => void
    currentIndex: number
    onFullscreenImageClick?: (imageIndex: number) => void
    onFullScreenOpen?: () => void
    shouldAutoplayVideo?: boolean
    enableCategorizedGallery?: boolean
    availableTabs?: CategoryTabOption[]
    activeCategoryTab?: CategoryTab
    onCategoryTabChange?: (tab: CategoryTab) => void
    getOverlayIndex: (image: Image) => number
}

export interface OverlayModalProps {
    images: Image[]
    video?: Image
    isOverlayOpen: boolean
    setOverlay: React.Dispatch<React.SetStateAction<boolean>>
    initialSlide: number
    setSelectedImage: (index: number) => void
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    onOverlayOpen?: () => void
    shouldAutoplayVideo?: boolean
    getOverlayCounter?: (overlayIndex: number) => SlideCounter | null
}

export interface OverlayCarouselProps {
    images: Image[]
    video?: Image
    setOverlay: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedImage: (index: number) => void
    isOverlayOpen: boolean
    initialSlide?: number
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    onOverlayOpen?: () => void
    shouldAutoplayVideo?: boolean
    getOverlayCounter?: (overlayIndex: number) => SlideCounter | null
}
